import { callGetApiToServer } from "../callApi";

export async function getDeletedBatchInventory(authtoken, batch_id, city) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Bearer " + authtoken,
    };

    let endUrl = `v1/auth/deleted-batch-inventory/${batch_id}?city=${city}`;
    let responseData = await callGetApiToServer(header, "GET", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
